import { Component, OnInit, Input } from '@angular/core';

// Service
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: [
  ]
})
export class FooterComponent implements OnInit {

  @Input() link;
  @Input() dataFooter;
  isLang;

  constructor( private apiService: ApiService ) { }

  ngOnInit(): void {
    //MultiLanguage
   this.isLang =  this.apiService.isLang();
  }

}
